import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const MiddleWing = () => {
  const homeMenu = [
    {
      label: "Curriculum",
      link: "",
      subMenu: [
        { label: "Primary Wing", link: "/primarywing" },
        { label: "Middle Wing", link: "/middleWing" },
        { label: "Senior Wing", link: "/seniorWing" },
        { label: "Curriculum", link: "/curriculum" },
      ],
    },

    {
      label: "Extended Classroom",
      link: "",
      subMenu: [
        { label: "Labs", link: "/mathmatics" },
        { label: "Excursions", link: "/excursions" },
        { label: "Library", link: "/library" },
        { label: "Field Trips", link: "/feildTrip" },
        { label: "Astronomy", link: "/astronomy" },
      ],
    },
    {
      label: "Sports",
      link: "",
      subMenu: [
        { label: "Sports", link: "/sports" },
        {
          label: "Achievements in Sports 2022-23",
          link: "/acheivementInSports",
        },
      ],
    },
    {
      label: "Arts",
      link: "",
      subMenu: [
        { label: "Performing Arts", link: "/music" },
        { label: "Visual Arts", link: "/visualArts" },
      ],
    },

    { label: "Houses", link: "/houses" },
    { label: "Assembly", link: "/assembly" },
    { label: "Book List", link: "/booklist" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-middle.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Middle Wing"
                breadEnd="Learning Approach"
                breadMid="Middle Wing"
              />
            </div>
          </div>
          <div className="row ">
            <div className="col-xl-12 mb-4">
              <h5 className="text-center color-green mb-4">
                <i>
                  “The function of Education is to teach one to think
                  intensively and to think critically. Intelligence plus
                  character-that is the goal of true education.”
                  <br />
                  -Martin Luther King, Jr
                </i>
              </h5>
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/middle1.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <p>
                Education in Middle and High Schools these days is rapidly
                changing. The conventional notion of a classroom where the
                students would sitting quietly and neatly in their seats, while
                the teacher would up front pour pearls of wisdom and knowledge
                into their brains is a practice of past. There has been a
                paradigm shift in the pedagogies from the old system and is
                constantly evolving with each passing year.
              </p>
              <p>
                Reality in the 21st century is quite contrary to the old
                methodology. Our students come into the classroom with the same
                attitudes and expectations as the society in which they live,
                from varied backgrounds. The main objective at school, hence, is
                to take up the responsibility of grooming children holistically,
                strengthening the scholastic and co-scholastic areas while
                reinforcing the value system or the ‘Sanskars’ to turn each
                Lotusian into a Good Samaritan.
              </p>
            </div>

            <div className="col-xl-12 mb-4">
              <h5 className="text-center color-green mb-4">
                <i>
                  “A carefully constructed structure of education is supposed to
                  smoothen the pursuit of knowledge, instead of restricting the
                  flow of knowledge.”
                </i>
              </h5>
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/middle2.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <p>
                The need of the hour is an educational system that works for and
                with students. Keeping in mind the present generation’s
                curiosity and eagerness to learn, it becomes imperative to adopt
                an approach that would take care of innovative student-centred
                learning environment enabling an educator to deal effectively
                with all types of students in the same classroom.
              </p>
              <p>
                Even an educator's role is changing from the traditional
                "imparter of knowledge" to that of coach and consultant. There
                are many exciting examples of successful strategies and programs
                in which the students are not only allowed, but encouraged and
                required, to take responsibility for much more of their learning
                than ever before.
              </p>
              <p>
                Do-it-yourself, student-to-student teaching, project-based
                learning, and student-centred learning environments are some of
                the more encouraging programs. Also, the integration of
                technology into every subject and at all grade levels allows
                unprecedented levels and types of exciting collaboration and
                learner to learner connectivity.
              </p>
              <p>
                Middle school offers maximum flexibility in terms of
                experiential and experimental learning. On one hand, there is
                lots to offer to the age bracket of middle school learners and
                lots of vitality that can be fruitfully manoeuvred, on the other
                hand, this age group is the most turbulent in terms of the
                emotional quotient, hence, maintaining a balance.
              </p>
              <p>
                Keeping all the above factors in view, we design working of
                students in small groups, perform different learning tasks and
                learn from different books. Teachers provide guidance, and all
                students have the opportunity to participate in school
                activities.
              </p>
              <p>
                Lotus Valley International School provides educational
                experiences that emphasize the instruction and overall
                well-being of learners. Working collaboratively, teachers,
                counsellors, administrators and many parents address middle
                school students’ learning and socialization needs and ensure
                some degree of success for all learners. They also recognize and
                address adolescents’ developmental diversity.
              </p>
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/middle3.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <p>
                We aim to recognize learner diversity, employ educators trained
                in middle school education, offer exploratory curricular
                programs that encourage learner interest, provide
                age-appropriate guidance and counselling, ensure equal access to
                educational experiences, promote a positive school environment,
                and involve parents and families in the educational process.
              </p>
              <p>
                It is important to state that the middle schools do not downplay
                academic achievement and appropriate behaviour. Quite the
                contrary, teachers and administrators emphasize these
                fundamental aspects of education, but they also provide learning
                experiences that meet individual needs.
              </p>
              <h5 className="text-center color-green mb-4">
                <i>
                  "Education means nourishing the mind and make it develop in
                  order to see beyond the limitations of current social
                  perception.”
                </i>
              </h5>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default MiddleWing;
